const errorStyle = {
  whiteSpace: 'pre-line',
};

export { errorStyle };
